<template>
  <div>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title class="title font-weight-bold">{{ !!componentIndex ? 'Edit component areas' : 'Add Component'}}</v-card-title>
        <v-card-text>
          <v-text-field
            v-model="txtName"
            label="Name"
            :rules="[v => !!v || 'Name is required']"
            required
          ></v-text-field>
          <canvas v-if="pcb && pcb.image" id="canvas" :width="canvasWidth" :height="canvasHeight" class="mt-3" :style="`background-image: url('` + pcb.image.largeUrl + `');`" style="background-size: contain;border:1px solid #ffffff;" />
          <v-btn
            block
            large
            class="mt-4"
            color="primary"
            :disabled="txtName === ''"
            @click="finish()"
          >
            Save
          </v-btn>
        </v-card-text>
      </v-card>
      <div id="contextMenu" class="context-menu" style="display:none;z-index:10000;">
        <ul class="menu" v-if="targetPolygonIndex !== null">
          <li v-if="targetPolyIndex !== null"><span style="cursor:pointer;" @click="deletePoly(targetPolygonIndex, targetPolyIndex)">Delete Point</span></li>
          <li v-else><span style="cursor:pointer;" @click="deletePolygon(targetPolygonIndex)">Delete Area</span></li>
        </ul>
      </div>
    </v-dialog>
  </div>
</template>

<style scoped>
.context-menu {
  border: 1px solid #fff;
  background-color: #333333;
  padding: 10px;
  position: fixed;
}
</style>

<script>
export default {
  props: {
    pcb: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      canvasWidth: 768,
      canvasHeight: 0,
      dialog: false,
      component: null,
      componentIndex: null,
      otherComponents: [],
      txtName: '',
      canvas: null,
      ctx: null,
      TEXT_OFFSET: 5,
      TEXT_COLOR: '#000',
      TEXT_SIZE: 16,
      FONT: 'arial',
      TEXT_ANGLE_OFFSET: 25,
      DEG: '°',
      p: 10,
      activePolygonIndex: undefined,
      activePointIndex: undefined,
      cursor: false,
      dragging: false,
      mouse: {
        x: 0,
        y: 0,
        button: false,
        lx: 0,
        ly: 0,
        update: true
      },
      Poly: null,
      polygons: [],
      polygonIndex: 0,
      targetPolygonIndex: null,
      targetPolyIndex: null,
      contextMenu: null
    }
  },

  watch: {
    pcb: {
      // This will let Vue know to look inside the array
      deep: true,

      // Will fire as soon as the component is created
      immediate: true,

      // We have to move our method to a handler field
      handler: function (val, oldVal) {
        console.log('pcb data updated')
        this.canvasHeight = (this.canvasWidth / val.image.originalWidth) * val.image.originalHeight
      }
    }
  },

  created () {
  },

  mounted () {
    this.contextMenu = document.getElementById('contextMenu')
    this.canvas = document.getElementById('canvas')
    this.canvas.addEventListener('mousedown', this.mouseEvents)
    this.canvas.addEventListener('mouseup', this.mouseEvents)
    this.canvas.addEventListener('mousemove', this.mouseEvents)

    this.ctx = this.canvas.getContext('2d')
    this.Rect = () => ({
      type: 'rect',
      vm: this,
      points: [],
      doneInit: false,
      closed: true,
      interactive: true,
      hover: false,
      init (mouse) {
        this.points.push(this.vm.point(mouse.lx, mouse.ly))
        this.points.push(this.vm.point(mouse.lx, mouse.ly))
        this.points.push(this.vm.point(mouse.lx, mouse.ly))
        this.points.push(this.vm.point(mouse.lx, mouse.ly))
        this.vm.activePolygonIndex = this.vm.polygonIndex
        this.vm.activePointIndex = 2
        this.vm.mouse.button = true
        this.vm.dragging = true
      },
      dragPoint (index, mouse) {
        if (this.interactive) {
          if (!this.doneInit) { this.doneInit = true }
          this.points[index].x += mouse.x - mouse.lx
          this.points[index].y += mouse.y - mouse.ly
          if (index === 0) {
            this.points[3].x += mouse.x - mouse.lx
            this.points[1].y += mouse.y - mouse.ly
          } else if (index === 1) {
            this.points[2].x += mouse.x - mouse.lx
            this.points[0].y += mouse.y - mouse.ly
          } else if (index === 2) {
            this.points[1].x += mouse.x - mouse.lx
            this.points[3].y += mouse.y - mouse.ly
          } else if (index === 3) {
            this.points[0].x += mouse.x - mouse.lx
            this.points[2].y += mouse.y - mouse.ly
          }
        }
      },
      move (mouse) {
        for (let i in this.points) {
          this.points[i].x += mouse.x - mouse.lx
          this.points[i].y += mouse.y - mouse.ly
        }
      },
      draw () {
        this.vm.ctx.lineWidth = 2
        this.vm.ctx.strokeStyle = (this.interactive ? (this.hover ? 'yellow' : 'red') : 'black')
        this.vm.ctx.fillStyle = (this.interactive ? 'rgba(255, 0, 0, 0.3)' : 'rgba(255, 255, 100, 0.3)')
        this.vm.ctx.beginPath()
        for (const p of this.points) { this.vm.ctx.lineTo(p.x, p.y) }
        this.closed && this.vm.ctx.closePath()
        this.vm.ctx.stroke()
        this.closed && this.vm.ctx.fill()

        if (this.interactive) {
          this.vm.ctx.fillStyle = 'rgba(0, 0, 0, 0.3)'
          this.vm.ctx.strokeStyle = 'rgba(0, 0, 0, 0.8)'
          for (const p of this.points) {
            this.vm.ctx.beginPath()
            this.vm.ctx.moveTo(p.x + 10, p.y)
            this.vm.ctx.arc(p.x, p.y, 10, 0, Math.PI * 2)
            this.vm.ctx.fill()
            this.vm.ctx.stroke()
          }
        }
        // this.points.length > 1 && this.drawLengthText()
        // this.points.length > 2 && this.drawAngleText()
      },
      closest (pos, dist = 8) {
        if (this.interactive) {
          var i = 0
          var index = -1
          dist *= dist
          for (const p of this.points) {
            var x = pos.x - p.x
            var y = pos.y - p.y
            var d2 = x * x + y * y
            if (d2 < dist) {
              dist = d2
              index = i
            }
            i++
          }
          if (index > -1) {
            return index
          }
        }
      }
    })

    // this.Poly = () => ({
    //   type: 'poly',
    //   vm: this,
    //   points: [],
    //   doneInit: true,
    //   closed: false,
    //   hover: false,
    //   addPoint (p) {
    //     if (!this.closed) {
    //       this.points.push(this.vm.point(p.x, p.y))
    //     }
    //   },
    //   dragPoint (index, mouse) {
    //     this.points[index].x += mouse.x - mouse.lx
    //     this.points[index].y += mouse.y - mouse.ly
    //   },
    //   draw () {
    //     this.vm.ctx.lineWidth = 2
    //     this.vm.ctx.strokeStyle = (this.hover ? 'yellow' : 'red')
    //     this.vm.ctx.fillStyle = 'rgba(255, 0, 0, 0.3)'
    //     this.vm.ctx.beginPath()
    //     for (const p of this.points) { this.vm.ctx.lineTo(p.x, p.y) }
    //     this.closed && this.vm.ctx.closePath()
    //     this.vm.ctx.stroke()
    //     this.closed && this.vm.ctx.fill()

    //     this.vm.ctx.fillStyle = 'rgba(0, 0, 0, 0.3)'
    //     this.vm.ctx.strokeStyle = 'rgba(0, 0, 0, 0.8)'
    //     for (const p of this.points) {
    //       this.vm.ctx.beginPath()
    //       this.vm.ctx.moveTo(p.x + 10, p.y)
    //       this.vm.ctx.arc(p.x, p.y, 10, 0, Math.PI * 2)
    //       this.vm.ctx.fill()
    //       this.vm.ctx.stroke()
    //     }
    //     // this.points.length > 1 && this.drawLengthText()
    //     // this.points.length > 2 && this.drawAngleText()
    //   },
    //   closest (pos, dist = 8) {
    //     var i = 0
    //     var index = -1
    //     dist *= dist
    //     for (const p of this.points) {
    //       var x = pos.x - p.x
    //       var y = pos.y - p.y
    //       var d2 = x * x + y * y
    //       if (d2 < dist) {
    //         dist = d2
    //         index = i
    //       }
    //       i++
    //     }
    //     if (index > -1) {
    //       return index
    //     }
    //   }
    //   // drawLengthText () {
    //   //   const len = this.points.length
    //   //   var p1; var i = 0
    //   //   p1 = this.points[i]
    //   //   while (i < len - (this.closed ? 0 : 1)) {
    //   //     const p2 = this.points[((i++) + 1) % len]
    //   //     const lineLength = ((p1.x - p2.x) ** 2 + (p1.y - p2.y) ** 2) ** 0.5
    //   //     this.vm.drawLineText(p1, p2, lineLength.toFixed(0) + 'px')
    //   //     if (len < 3) { break }
    //   //     p1 = p2
    //   //   }
    //   //   this.vm.ctx.setTransform(1, 0, 0, 1, 0, 0)
    //   // },
    //   // drawAngleText () {
    //   //   const len = this.points.length
    //   //   var p1; var p2; var i = this.closed ? 0 : 1
    //   //   p1 = this.points[(i + len - 1) % len]
    //   //   p2 = this.points[i]
    //   //   while (i < len - (this.closed ? 0 : 1)) {
    //   //     const p3 = this.points[((i++) + 1) % len]
    //   //     this.vm.drawAngleText(p1, p2, p3)
    //   //     p1 = p2
    //   //     p2 = p3
    //   //   }
    //   //   this.vm.ctx.setTransform(1, 0, 0, 1, 0, 0)
    //   // }
    // })
    window.requestAnimationFrame(this.update)
    this.canvas.oncontextmenu = this.rightClick
  },

  methods: {
    show: function (componentIndex = null) {
      console.log('show', componentIndex)
      this.componentIndex = componentIndex
      this.polygons = []
      this.polygonIndex = 0
      this.targetPolygonIndex = null
      this.targetPolyIndex = null
      this.txtName = ''

      for (let i in this.pcb.components) {
        for (let j in this.pcb.components[i].areas) {
          // const poly = new this.Poly()
          // poly.points = this.pcb.components[i].areas[j].points
          // poly.closed = this.pcb.components[i].areas[j].closed
          // this.polygons.push(poly)

          let area = this.pcb.components[i].areas[j]
          const rect = new this.Rect()
          rect.points = [
            {
              x: (area.x / 100) * this.canvasWidth,
              y: (area.y / 100) * this.canvasHeight
            },
            {
              x: ((area.x + area.width) / 100) * this.canvasWidth,
              y: (area.y / 100) * this.canvasHeight
            },
            {
              x: ((area.x + area.width) / 100) * this.canvasWidth,
              y: ((area.y + area.height) / 100) * this.canvasHeight
            },
            {
              x: (area.x / 100) * this.canvasWidth,
              y: ((area.y + area.height) / 100) * this.canvasHeight
            }
          ]
          rect.doneInit = true
          if (componentIndex !== null && Number(i) === Number(componentIndex)) {
            rect.interactive = true
          } else {
            rect.interactive = false
          }
          this.polygons.push(rect)
          console.log('schematicComponent show ' + j, rect.points)
          this.polygonIndex = j
        }
      }
      if (componentIndex !== null) {
        this.txtName = this.pcb.components[componentIndex].name
      }
      this.mouse.update = true
      setTimeout(() => {
        this.dialog = true
      }, 100)
    },
    finish: function () {
      let tmpAreas = []
      for (let i in this.polygons) {
        if (this.polygons[i].interactive) {
          let top = 0
          let left = 0
          let right = 0
          let bottom = 0
          for (let j in this.polygons[i].points) {
            if (left === 0 || this.polygons[i].points[j].x < left) {
              left = this.polygons[i].points[j].x
            }
            if (right === 0 || this.polygons[i].points[j].x > right) {
              right = this.polygons[i].points[j].x
            }
            if (top === 0 || this.polygons[i].points[j].y < top) {
              top = this.polygons[i].points[j].y
            }
            if (bottom === 0 || this.polygons[i].points[j].y > bottom) {
              bottom = this.polygons[i].points[j].y
            }
          }
          tmpAreas.push({
            x: (left / this.canvasWidth) * 100,
            y: (top / this.canvasHeight) * 100,
            width: ((right - left) / this.canvasWidth) * 100,
            height: ((bottom - top) / this.canvasHeight) * 100
          })
        }
      }
      if (tmpAreas.length > 0) {
        if (this.txtName !== '') {
          this.$emit('finished', tmpAreas, this.componentIndex, this.txtName)
          this.dialog = false
        } else {
          window.alert('Component name is required')
        }
      } else {
        window.alert('Component area is required')
      }
    },
    deletePolygon: function (index) {
      this.polygons.splice(index, 1)
      this.polygonIndex = this.polygons.length - 1
      this.contextMenu.style.display = 'none'
      this.mouse.update = true
      this.update()
    },
    deletePoly: function (polygonIndex, polyIndex) {
      this.polygons[polygonIndex].points.splice(polyIndex, 1)
      if (this.polygons[polygonIndex].points.length === 0) {
        this.polygons.splice(polygonIndex, 1)
        this.polygonIndex = this.polygons.length - 1
      } else if (this.polygons[polygonIndex].points.length <= 2) {
        this.polygons[polygonIndex].closed = false
        this.polygonIndex = polygonIndex
      }
      this.contextMenu.style.display = 'none'
      this.mouse.update = true
      this.update()
    },
    rightClick: function (e) {
      e.preventDefault()
      this.mouse.button = false
      const bounds = this.canvas.getBoundingClientRect()
      this.mouse.x = e.pageX - bounds.left - window.scrollX
      this.mouse.y = e.pageY - bounds.top - window.scrollY
      let polygonHoverIndex = null
      // let polyHoverIndex = null
      for (let i in this.polygons) {
        if (this.polygons[i].closed && this.polygons[i].interactive) {
          if (this.isInside(this.mouse, this.polygons[i].points)) {
            this.polygons[i].hover = true
            polygonHoverIndex = Number(i)
          }
        }
        // let closestPolyIndex = this.polygons[i].closest(this.mouse)
        // if (closestPolyIndex !== undefined) {
        //   polygonHoverIndex = Number(i)
        //   polyHoverIndex = closestPolyIndex
        //   break
        // }
      }
      // if (polyHoverIndex !== null || polygonHoverIndex !== null) {
      if (polygonHoverIndex !== null) {
        this.targetPolygonIndex = null
        if (polygonHoverIndex >= 0) {
          this.targetPolygonIndex = polygonHoverIndex
        }
        // this.targetPolyIndex = null
        // if (polyHoverIndex >= 0) {
        //   this.targetPolyIndex = polyHoverIndex
        // }
        this.contextMenu.style.left = e.clientX + 'px'
        this.contextMenu.style.top = e.clientY + 'px'
        this.contextMenu.style.display = 'block'
      }
    },
    mouseEvents: function (e) {
      const bounds = this.canvas.getBoundingClientRect()
      this.mouse.x = e.pageX - bounds.left - window.scrollX
      this.mouse.y = e.pageY - bounds.top - window.scrollY
      for (let i in this.polygons) {
        this.polygons[i].hover = false
      }
      if (e.type === 'mousedown' && this.contextMenu.style.display === 'block') {
        this.contextMenu.style.display = 'none'
      } else if (this.mouse.x > 0 && this.mouse.x < this.canvas.width && this.mouse.y > 0 && this.mouse.y < this.canvas.height) {
        this.mouse.button = (e.type === 'mousedown' ? true : e.type === 'mouseup' ? false : this.mouse.button)
        this.mouse.update = true
      }
    },

    update: function () {
      if (this.dialog === true && this.mouse.update) {
        this.cursor = 'crosshair'
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
        if (this.polygons.length > 0 && !this.dragging) {
          // check if last area is not initialized properly
          if (this.polygons[this.polygons.length - 1].doneInit === false) {
            this.polygons.pop()
            this.polygonIndex = this.polygons.length - 1
          }
          this.activePolygonIndex = undefined
          this.activePointIndex = undefined
          for (let i in this.polygons) {
            if (this.polygons[i].closed && this.polygons[i].interactive) {
              if (this.isInside(this.mouse, this.polygons[i].points)) {
                this.polygons[i].hover = true
                this.activePolygonIndex = i
                this.cursor = 'move'
              }
            }
            let closestPolyIndex = this.polygons[i].closest(this.mouse)
            if (closestPolyIndex !== undefined) {
              // this.activePointIndex = this.polygons[i].points[closestPolyIndex]
              this.activePolygonIndex = i
              this.activePointIndex = closestPolyIndex
              break
            }
          }
        }
        if (this.activePolygonIndex === undefined && this.activePointIndex === undefined && this.mouse.button) {
          if (this.polygons.length === 0 || (this.polygons.length > 0 && this.polygons[this.polygonIndex].closed)) {
            // this.polygons.push(new this.Poly())
            this.polygons.push(new this.Rect())
            this.polygonIndex = this.polygons.length - 1
            this.polygons[this.polygonIndex].init(this.mouse)
          } else {
            this.mouse.button = false
          }
          // this.polygons[this.polygonIndex].addPoint(this.mouse)
          // this.mouse.button = false
        } else if (this.activePointIndex >= 0) {
          if (this.mouse.button) {
            if (this.dragging) {
              this.polygons[this.activePolygonIndex].dragPoint(this.activePointIndex, this.mouse)
              // this.activePointIndex.x += this.mouse.x - this.mouse.lx
              // this.activePointIndex.y += this.mouse.y - this.mouse.ly
            } else {
              if (!this.polygons[this.polygonIndex].closed && this.polygons[this.polygonIndex].points.length > 2 && this.activePointIndex === 0) {
                this.polygons[this.polygonIndex].closed = true
                for (let i in this.polygons) {
                  if (!this.polygons[i].closed) {
                    this.polygonIndex = i
                  }
                }
              }
              this.dragging = true
            }
          } else { this.dragging = false }
        } else if (this.activePolygonIndex >= 0) {
          if (this.mouse.button) {
            if (this.dragging) {
              this.polygons[this.activePolygonIndex].move(this.mouse)
            } else {
              this.dragging = true
            }
          } else {
            this.dragging = false
          }
        }

        // redraw
        for (let i in this.polygons) {
          this.polygons[i].draw()
        }
        if (this.activePointIndex >= 0) {
          this.drawCircle(this.activePolygonIndex, this.activePointIndex)
          this.cursor = 'move'
        }
        this.mouse.lx = this.mouse.x
        this.mouse.ly = this.mouse.y
        this.canvas.style.cursor = this.cursor
        this.mouse.update = false
        // console.log('update', this.activePolygonIndex, this.activePointIndex)
      }
      window.requestAnimationFrame(this.update)
    },

    isInside: function (point, vs) {
      // ray-casting algorithm based on https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html
      let x = point.x; let y = point.y
      let inside = false
      for (let i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        let xi = vs[i].x
        let yi = vs[i].y
        let xj = vs[j].x
        let yj = vs[j].y
        let intersect = ((yi > y) !== (yj > y)) &&
            (x < (xj - xi) * (y - yi) / (yj - yi) + xi)
        if (intersect) inside = !inside
      }
      return inside
    },
    point: function (x, y) {
      return { x, y }
    },
    drawCircle: function (polygonIndex, pointIndex, color = 'orange', size = 8) {
      let pos = this.polygons[polygonIndex].points[pointIndex]
      this.ctx.strokeStyle = color
      this.ctx.beginPath()
      this.ctx.arc(pos.x, pos.y, size, 0, Math.PI * 2)
      this.ctx.stroke()
    }

    // drawLineText: function (p1, p2, text, textOffset = this.TEXT_OFFSET, textColor = this.TEXT_COLOR, textSize = this.TEXT_SIZE, font = this.FONT) {
    //   var x = p1.x; var y = p1.y
    //   var nx = p2.x - x; var ny = p2.y - y; var len = (nx * nx + ny * ny) ** 0.5
    //   nx /= len
    //   ny /= len
    //   this.ctx.font = textSize + 'px ' + font
    //   this.ctx.textAlign = 'center'
    //   this.ctx.fillStyle = textColor
    //   if (nx < 0) {
    //     this.ctx.textBaseline = 'top'
    //     x = p2.x
    //     y = p2.y
    //     nx = -nx
    //     ny = -ny
    //     textOffset = -textOffset
    //   } else { this.ctx.textBaseline = 'bottom' }
    //   len /= 2
    //   this.ctx.setTransform(nx, ny, -ny, nx, x, y)
    //   this.ctx.fillText(text, len, -textOffset)
    // },

    // // angle between p2-p1 and p2-p3
    // drawAngleText: function (p1, p2, p3, textAngleOffset = this.TEXT_ANGLE_OFFSET, textColor = this.TEXT_COLOR, textSize = this.TEXT_SIZE, font = this.FONT) {
    //   var ang
    //   var x = p2.x; var y = p2.y
    //   var nx1 = p1.x - x; var ny1 = p1.y - y; var len1 = (nx1 * nx1 + ny1 * ny1) ** 0.5
    //   var nx2 = p3.x - x; var ny2 = p3.y - y; var len2 = (nx2 * nx2 + ny2 * ny2) ** 0.5
    //   nx1 /= len1
    //   ny1 /= len1
    //   nx2 /= len2
    //   ny2 /= len2
    //   const cross = nx1 * ny2 - ny1 * nx2
    //   const dot = nx1 * nx2 + ny1 * ny2
    //   if (dot < 0) {
    //     ang = cross < 0 ? -Math.PI - Math.asin(cross) : Math.PI - Math.asin(cross)
    //   } else {
    //     ang = Math.asin(cross)
    //   }
    //   const angDeg = Math.abs(ang * (180 / Math.PI)).toFixed(0) + this.DEG
    //   this.ctx.font = textSize + 'px ' + font
    //   this.ctx.fillStyle = textColor
    //   this.ctx.textBaseline = 'middle'
    //   const centerAngle = Math.atan2(ny1, nx1) + ang / 2
    //   const nx = Math.cos(centerAngle)
    //   const ny = Math.sin(centerAngle)
    //   if (nx < 0) {
    //     this.ctx.textAlign = 'right'
    //     this.ctx.setTransform(-nx, -ny, ny, -nx, x, y)
    //     textAngleOffset = -textAngleOffset
    //   } else {
    //     this.ctx.textAlign = 'left'
    //     this.ctx.setTransform(nx, ny, -ny, nx, x, y)
    //   }
    //   this.ctx.fillText(angDeg, textAngleOffset, 0)
    // }
  }
}

</script>
